import weapons01 from "../images/canvasEquipment/weapons01.png";
import weapons02 from "../images/canvasEquipment/weapons02.png";
import weapons03 from "../images/canvasEquipment/weapons03.png";
import weapons04 from "../images/canvasEquipment/weapons04.png";
import weapons05 from "../images/canvasEquipment/weapons05.png";
import weapons06 from "../images/canvasEquipment/weapons06.png";
import weapons07 from "../images/canvasEquipment/weapons07.png";
import weapons08 from "../images/canvasEquipment/weapons08.png";
import weapons09 from "../images/canvasEquipment/weapons09.png";
import weapons10 from "../images/canvasEquipment/weapons10.png";
import headgears01 from "../images/canvasEquipment/headgears01.png";
import headgears02 from "../images/canvasEquipment/headgears02.png";
import headgears03 from "../images/canvasEquipment/headgears03.png";
import headgears04 from "../images/canvasEquipment/headgears04.png";
import headgears05 from "../images/canvasEquipment/headgears05.png";
import headgears06 from "../images/canvasEquipment/headgears06.png";
import headgears07 from "../images/canvasEquipment/headgears07.png";
import headgears08 from "../images/canvasEquipment/headgears08.png";
import headgears09 from "../images/canvasEquipment/headgears09.png";
import face00 from "../images/canvasEquipment/face00.png";
import face01 from "../images/canvasEquipment/face01.png";
import face02 from "../images/canvasEquipment/face02.png";
import face03 from "../images/canvasEquipment/face03.png";
import face04 from "../images/canvasEquipment/face04.png";
import face05 from "../images/canvasEquipment/face05.png";
import face06 from "../images/canvasEquipment/face06.png";
import pets01 from "../images/canvasEquipment/pets01.png";
import pets02 from "../images/canvasEquipment/pets02.png";
import pets03 from "../images/canvasEquipment/pets03.png";
import pets04 from "../images/canvasEquipment/pets04.png";
import pets05 from "../images/canvasEquipment/pets05.png";
import pets06 from "../images/canvasEquipment/pets06.png";
import cloaks01 from "../images/canvasEquipment/cloaks01.png";
import cloaks02 from "../images/canvasEquipment/cloaks02.png";
import cloaks03 from "../images/canvasEquipment/cloaks03.png";
import cloaks03_1 from "../images/canvasEquipment/cloaks03-1.png";
import cloaks04 from "../images/canvasEquipment/cloaks04.png";
import cloaks05 from "../images/canvasEquipment/cloaks05.png";
import cloaks06 from "../images/canvasEquipment/cloaks06.png";
import wafers01 from "../images/canvasEquipment/wafers01.png";
import wafers02 from "../images/canvasEquipment/wafers02.png";
import wafers03 from "../images/canvasEquipment/wafers03.png";
import wafers04 from "../images/canvasEquipment/wafers04.png";
import wafers05 from "../images/canvasEquipment/wafers05.png";
import wafers06 from "../images/canvasEquipment/wafers06.png";
import background01 from "../images/canvasEquipment/background01.png";
import background02 from "../images/canvasEquipment/background02.png";
import background03 from "../images/canvasEquipment/background03.png";
import background04 from "../images/canvasEquipment/background04.png";
import canvasBg01 from "../images/canvasEquipment/canvas_bg01.png";
import canvasBg02 from "../images/canvasEquipment/canvas_bg02.png";
import canvasBg03 from "../images/canvasEquipment/canvas_bg03.png";
import canvasBg04 from "../images/canvasEquipment/canvas_bg04.png";
import canvasBgSmall01 from "../images/canvasEquipment/canvas_bg_small01.png";
import canvasBgSmall02 from "../images/canvasEquipment/canvas_bg_small02.png";
import canvasBgSmall03 from "../images/canvasEquipment/canvas_bg_small03.png";
import canvasBgSmall04 from "../images/canvasEquipment/canvas_bg_small04.png";

const images = {
  weapons01,
  weapons02,
  weapons03,
  weapons04,
  weapons05,
  weapons06,
  weapons07,
  weapons08,
  weapons09,
  weapons10,
  headgears01,
  headgears02,
  headgears03,
  headgears04,
  headgears05,
  headgears06,
  headgears07,
  headgears08,
  headgears09,
  face00,
  face01,
  face02,
  face03,
  face04,
  face05,
  face06,
  pets01,
  pets02,
  pets03,
  pets04,
  pets05,
  pets06,
  cloaks01,
  cloaks02,
  cloaks03,
  cloaks03_1,
  cloaks04,
  cloaks05,
  cloaks06,
  wafers01,
  wafers02,
  wafers03,
  wafers04,
  wafers05,
  wafers06,
  background01,
  background02,
  background03,
  background04,
  canvasBg01,
  canvasBg02,
  canvasBg03,
  canvasBg04,
  canvasBgSmall01,
  canvasBgSmall02,
  canvasBgSmall03,
  canvasBgSmall04,
};

export default images;
